"use client";

import { useStyleController } from "@/hooks/useStyleController.hook";
import React from "react";

type Props = {
  children: React.ReactNode;
};

const ScrollTarget: React.FC<Props> = ({ children }) => {
  const {
    refControl: { scrollDownTarget },
  } = useStyleController();

  return <div ref={scrollDownTarget}>{children}</div>;
};

export default ScrollTarget;
